"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRegItemPublic = void 0;
const FormFieldValue_1 = require("./FormFieldValue");
class EventRegItemPublic {
    constructor(id, firstName, lastName, values, created) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.values = values;
        this.created = created;
    }
    static fromDto(dto) {
        return new EventRegItemPublic(dto.id, dto.name ? dto.name.first : "", dto.name ? dto.name.last : "", dto.values ? dto.values.map(dto => FormFieldValue_1.FormFieldValue.fromDto(dto)) : [], dto.created);
    }
    get name() {
        return this.firstName + " " + this.lastName;
    }
    get hasName() {
        return this.firstName.length > 0 || this.lastName.length > 0;
    }
}
exports.EventRegItemPublic = EventRegItemPublic;
